import { useQueryClient } from "@tanstack/react-query";
import { CognitoUser } from "amazon-cognito-identity-js";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Login, safeSessionStorage } from "@examspark/common-app";
import { CautionBanner, useResolvedUrl, VSpace } from "@examspark/common-ui";

import { useFlags } from "../../hooks/useFlags";

const LoginRoute = () => {
  const [, setUser] = useState<CognitoUser>();
  const navigate = useNavigate();
  const location = useLocation();
  const flags = useFlags();
  const classlinkRedirectUrl = useResolvedUrl("/login/oidc/classlink");
  const search = new URLSearchParams(location.search);

  // clear entire react query cache
  const client = useQueryClient();
  useEffect(() => {
    client.invalidateQueries();
  }, [client]);

  let classlinkUrl: URL | undefined;
  if (
    process.env.REACT_APP_CLASSLINK_CLIENT_ID != null &&
    flags.enableLoginWithClasslink
  ) {
    classlinkUrl = new URL("https://launchpad.classlink.com/oauth2/v2/auth");
    classlinkUrl.searchParams.set("scope", "openid");
    classlinkUrl.searchParams.set(
      "redirect_uri",
      classlinkRedirectUrl.toString(),
    );
    classlinkUrl.searchParams.set(
      "client_id",
      process.env.REACT_APP_CLASSLINK_CLIENT_ID,
    );
    classlinkUrl.searchParams.set("response_type", "code");
  }

  return (
    <Login
      onRegisterButtonClick={() => navigate("/login/register")}
      header={
        <VSpace>
          <h1>Member District Login</h1>
          <CautionBanner variant="contained">
            If you have not registered for Go TCMPC and are unable to login,
            please contact your Administrator or your Education Service Center.
          </CautionBanner>
        </VSpace>
      }
      allowRegistration
      loginWithText="Login with ClassLink"
      loginWithUrl={classlinkUrl?.toString()}
      onLogin={(user) => {
        setUser(user);
        // if the user is redirected from a page, go back to that page
        if (search.get("redirect") === "true") {
          try {
            const lastLocation =
              safeSessionStorage.getItem("redirect_on_login");

            if (lastLocation) {
              safeSessionStorage.removeItem("redirect_on_login");
              navigate(lastLocation);
            } else {
              navigate("/");
            }
          } catch {
            navigate("/");
          }
        } else {
          navigate("/");
        }
      }}
    />
  );
};

export default LoginRoute;
